// src/components/FormBuilder/questionTypeConstants.js
export const QUESTION_TYPES = {
    TEXT: 'text',
    PARAGRAPH: 'paragraph',
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
    DROPDOWN: 'dropdown',
    DATE: 'date',
    TIME: 'time',
    RATING: 'rating',
    LINEAR_SCALE: 'linear_scale',
    FILE: 'file',
};
